import React, { useState } from "react";
import { AntdButton, Container, Inner, Section } from "./styles.js";
import { Typo } from "../../../../../../components/layout/theme/index.js";
import { Button, Col } from "antd";
import moment from "moment";
import { useReport } from "../../../../../../contexts/ReportContext.js";
import { PaymentMethods } from "../../../../../../components/common/payment-methods/PaymentMethods.js";



const EmissionPaymentMethod = ({
	nextSubStep,
	handleFinishQuotation,
	isMobile,
}) => {
	const { updateReportForm } = useReport();
	const [selectedPayment, setSelectedPayment] = useState(null);

	const onAddPaymentMethod = (method) => {
		setSelectedPayment(method);
		
		// Guardar método de pago en el contexto
		updateReportForm({
			paymentMethod: method
		});
	};

	const onDeletePaymentMethod = async () => {
		setSelectedPayment(null);
		
		// Limpiar método de pago del contexto
		updateReportForm({
			paymentMethod: {}
		});
	}


	const renderSelectedPayment = () => {
		switch (selectedPayment.type) {
			case "cashMethodData":
				return (
					<Col>
						<p>
							Metodo: Efectivo
						</p>
						<p>
							Moneda: {selectedPayment.currencyName}
						</p>
					</Col>
				);
			case "bankAccountData":
				return (
					<Col>
						<p>
							Metodo: Cuenta Bancaria
						</p>
						<p>
							Banco:{" "}
							{selectedPayment.bankBranch.bank.name}
						</p>
						<p>
							Numero de cuenta: {selectedPayment.number}
						</p>
						<p>
							CBU: {selectedPayment.cbu}
						</p>
					</Col>
				);
			case "creditCardData":
				return (
					<Col>
						<p>
							Metodo: Tarjeta de credito/debito
						</p>
						<p>
							Tipo de tarjeta:{" "}
							{selectedPayment.cardType.name}
						</p>
						<p>
							Proveedor:{" "}
							{selectedPayment.cardProvider?.name}
						</p>
						<p>
							Titular: {selectedPayment.ownerName}
						</p>
						<p>
							Nro de tarjeta:{" "}
							{`XXXX-XXXX-XXXX-${selectedPayment.number.substr(
								selectedPayment.number.length - 4
							)}`}
						</p>
						<p>
							Fecha de vencimiento:{" "}
							{/* dateTo se guarda en formato YYYY-MM-DD (ver
							CreatePaymentCredit.js); acá se re-formatea a MM/YY
							para mostrar consistentemente lo mismo que el
							usuario ingresó en el DatePicker. */}
							{moment(selectedPayment.dateTo).format("MM/YY")}
						</p>

					</Col>
				);
			default:
				return <p>Medio de pago no reconocido</p>;
		}
	};


	return (
		<Inner>
			<Typo level={isMobile ? 3 : 2} style={{ textAlign: "center" }}>
				¡Todo listo! sólo falta que elijas cómo querés pagar
			</Typo>
			<Container>
				{selectedPayment ? (
					<Col>
						{renderSelectedPayment()}

						<Button
							type="primary"
							danger
							onClick={() => onDeletePaymentMethod()}
						>
							{"Eliminar"}
						</Button>
					</Col>
				) :
					(<PaymentMethods
						onAddPaymentMethod={onAddPaymentMethod}
						fixedFooter={false}
						dataFormattedForEndpoint={true}
					/>)}
			</Container>
			<Section style={{ maxWidth: "280px", maxHeight: "100px" }}>
				<AntdButton
					key="PrevStep2CarParsonalData"
					onClick={() => nextSubStep(0)}
				>
					<Typo level={5}>Anterior</Typo>
				</AntdButton>
				<AntdButton
					key="NextStep2CarPersonalData"
					type="primary"
					onClick={handleFinishQuotation}
					disabled={!selectedPayment}
				>
					<Typo level={5} type="white">
						Confirmar pago
					</Typo>
				</AntdButton>
			</Section>
		</Inner>
	);
};

export default EmissionPaymentMethod;
